module.exports = __webpack_public_path__ + "img/26.a2224b7a.svg";